module.exports = __webpack_public_path__ + "img/package_water.93ea0d3b.svg";